import { useQuery } from "@tanstack/react-query";

const STORAGE_KEY = "squawk.playerV2Enabled";

export const useGetSquawkPlayerV2 = () => {
  return useQuery({
    queryKey: ["squawkPlayerV2Pref"],
    queryFn: () => {
      return localStorage.getItem(STORAGE_KEY) === "true";
    },
    // No network request — reads from localStorage synchronously
    staleTime: Infinity,
  });
};
